import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import { FormControl } from "@mui/material";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ListItemIcon } from "@mui/material";
import { Settings } from "@mui/icons-material";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  outline: "none",
  p: 4,
  marginTop: 3,
};

const theme = createTheme({
  palette: {
    neutral: {
      main: "#F0411A",
      contrastText: "#fff",
    },
  },
});

const PasswordChangeModal = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [oldPassword, setoldPassword] = useState("");
  const [newPassword, setnewPassword] = useState("");
  // const [age, setAge] = React.useState("");

  // const handleChange = (event) => {
  //   setAge(event.target.value);
  // };
  const handleCreateUser = async () => {
    if (!oldPassword) {
      toast.warning("please enter oldPassword");
      return;
    }
    if (!newPassword) {
      toast.warning("please enter newPassword");
      return;
    }

    try {
      const res = await axios.post(
        `api/v1/users/updateUserPassword`,
        { oldPassword,newPassword },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            withCredentials: true,
            // Authorization: token,
          },
        }
      );
      console.log(res);
      if (res.status === 200 || res.statusText === "OK") {
        toast.success("success");
        // setRender(!render);
        setoldPassword("");
        setnewPassword("");
        handleClose();
        return;
      }
    } catch (err) {
      // toast.error(err);
      console.log(err.response.data.message);
      // toast.error(err.response.data.message);
    }
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <MenuItem onClick={handleOpen}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Password Change
        </MenuItem>
      </ThemeProvider>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {/* <Typography id="modal-modal-title" variant="h6" component="h2">
            Create Two Digit Lucky Number
          </Typography> */}
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <TextField
              sx={{ width: "100%" }}
              id="outlined-search"
              label="Old Password"
              type="password"
              value={oldPassword}
              onChange={(e) => {
                setoldPassword(e.target.value);
              }}
            />
            <TextField
              sx={{ width: "100%", marginTop: 1 }}
              id="outlined-search"
              label="New Passowrd"
              type="password"
              value={newPassword}
              onChange={(e) => {
                setnewPassword(e.target.value);
              }}
            />
            <ThemeProvider theme={theme}>
              <Button
                onClick={handleCreateUser}
                sx={{ marginTop: 3, boxShadow: "none !important" }}
                variant="contained"
                color="neutral"
              >
                Save
              </Button>
            </ThemeProvider>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default PasswordChangeModal;
